import React from 'react';

import { CustomMessageActions } from '../../context/MessageContext';

import type { StreamMessage } from '../../context/ChannelStateContext';
import type { DefaultBeloChatGenerics } from '../../types/types';

export type CustomMessageActionsListProps<
  BeloChatGenerics extends DefaultBeloChatGenerics = DefaultBeloChatGenerics
> = {
  message: StreamMessage<BeloChatGenerics>;
  customMessageActions?: CustomMessageActions<BeloChatGenerics>;
};

/**
 * @deprecated alias for `CustomMessageActionsListProps`, will be removed in the next major release
 */
export type CustomMessageActionsType<
  BeloChatGenerics extends DefaultBeloChatGenerics = DefaultBeloChatGenerics
> = CustomMessageActionsListProps<BeloChatGenerics>;

export const CustomMessageActionsList = <
  BeloChatGenerics extends DefaultBeloChatGenerics = DefaultBeloChatGenerics
>(
  props: CustomMessageActionsListProps<BeloChatGenerics>,
) => {
  const { customMessageActions, message } = props;

  if (!customMessageActions) return null;

  const customActionsArray = Object.keys(customMessageActions);

  return (
    <>
      {customActionsArray.map((customAction) => {
        const customHandler = customMessageActions[customAction];

        return (
          <button
            aria-selected='false'
            className='str-chat__message-actions-list-item str-chat__message-actions-list-item-button'
            key={customAction}
            onClick={(event) => customHandler(message, event)}
            role='option'
          >
            {customAction}
          </button>
        );
      })}
    </>
  );
};
